import React from "react";
import StandardModal from "../shared/Modal/StandardModal";
import "./DeleteVideoModal.css";

function DeleteVideoModal({ isOpen, onClose, video, onConfirmDelete }) {
  if (!video) return null;

  return (
    <StandardModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Video"
      footerCenter={
        <>
          <button
            className="btn btn-danger btn-md"
            onClick={() => {
              onConfirmDelete(video.id);
              onClose();
            }}
          >
            Delete Video
          </button>
        </>
      }
    >
      <div className="delete_video_modal">
        <div className="delete-video-modal-content">
          <div className="delete-video-modal-confirmation-message">
            <p>Are you sure you want to delete the video:</p>
            <div className="delete-video-modal-video-title">
              {video.video_title || "Untitled Video"}
            </div>
          </div>

          <p className="delete-video-modal-warning-text">
            This action cannot be undone.
          </p>
        </div>
      </div>
    </StandardModal>
  );
}

export default DeleteVideoModal;
